<template>
  <div class="menu-container">
    <el-menu 
      :default-active="activeCategory" 
      class="product-menu"
      background-color="transparent"
      text-color="#333"
      active-text-color="#409EFF">
      <el-menu-item index="0" @click="categoryChange('0')">
        <el-icon><Grid /></el-icon>
        <span>全部</span>
      </el-menu-item>
      <ProductLeftSubMenu
        :menu="menu"
        v-for="menu in menuList"
        :key="menu.categoryId"
        @category-change="categoryChange">
      </ProductLeftSubMenu>
    </el-menu>
  </div>
</template>

<script setup>
import { Grid } from "@element-plus/icons-vue";

// 定义props
const props = defineProps({
  menuList: {
    type: Array,
    default: () => [],
  },
  activeCategory: {
    type: String,
    default: '0'
  }
})

const emit = defineEmits(['category-change']);

const categoryChange = (categoryId) => {
  emit('category-change', categoryId);
};
</script>

<style lang="less" scoped>
.menu-container {
  width: 240px;
  min-width: 240px;
  margin-right: 20px;
  margin-bottom: 30px;

  .product-menu {
    border-radius: 4px;

    :deep(.el-menu-item) {
      height: 50px;
      line-height: 50px;

      &:hover {
        background-color: rgba(236, 245, 255, 0.6);
      }

      &.is-active {
        font-weight: bold;
        background-color: rgba(236, 245, 255, 0.6);
      }
    }

    :deep(.el-sub-menu__title) {
      height: 50px;
      line-height: 50px;

      &:hover {
        background-color: rgba(236, 245, 255, 0.6);
      }
    }

    .el-icon {
      margin-right: 5px;
      width: 24px;
      text-align: center;
    }
  }
}
</style>
